// extracted by mini-css-extract-plugin
export default {"content":"leftovers-tab_content__BCjJc","profitBadge":"leftovers-tab_profitBadge__hKmdd","profit":"leftovers-tab_profit__Gr6ke","specs":"leftovers-tab_specs__Qmp8Y"};